import React from 'react'
import { Helmet } from 'react-helmet'

import appleTouch from '../../images/apple-touch-icon.png'
import favicon16 from '../../images/favicon-16x16.png'
import favicon32 from '../../images/favicon-32x32.png'
import safariPinnedTab from '../../images/safari-pinned-tab.svg'

const Meta = ({ config: _default, meta }) => {
    // Breadcrumbs structured data
    let breadcrumbsJsonLd = null;
    const siteUrl = _default?.site_url || (typeof window !== 'undefined' ? window.location.origin : '');
    if (typeof window !== 'undefined') {
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        const breadcrumbItems = [
            {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: siteUrl + '/',
            },
            ...pathParts.map((part, idx) => ({
                '@type': 'ListItem',
                position: idx + 2,
                name: decodeURIComponent(part.replace(/-/g, ' ')),
                item: siteUrl + '/' + pathParts.slice(0, idx + 1).join('/') + '/',
            })),
        ];
        breadcrumbsJsonLd = {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            'itemListElement': breadcrumbItems,
        };
    }
    const title = meta?.title ?? _default?.page_title;
    const description = meta?.description ?? _default?.meta_description;
    const shareImage = meta?.shareImage?.url ?? _default?.share_image?.url;
    const cardType = 'summary_large_image';
    const pageUrl = typeof window !== 'undefined' ? window.location.href : siteUrl;

    const organizationJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        'name': 'Ministry of Defence Brochure',
        'url': siteUrl,
        'logo': shareImage,
    };
    const websiteJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        'url': siteUrl,
        'name': 'Ministry of Defence Brochure',
        'description': description,
    };
    return (
        <Helmet>
            <link rel="apple-touch-icon" sizes="180x180" href={appleTouch} />
            <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
            <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
            <link rel="mask-icon" href={safariPinnedTab} color="#000b1d" />
            <meta name="msapplication-TileColor" content="#000b1d" />
            <meta name="theme-color" content="#ffffff" />

            <title>{title}</title>
            <meta name="description" content={description} />

            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={shareImage} />
            <meta property="og:url" content={pageUrl} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Ministry of Defence Brochure" />

            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={shareImage} />
            <meta name="twitter:card" content={cardType} />
            {/* <meta name="twitter:site" content="@modproducts" /> */}

            {/* Canonical link */}
            <link rel="canonical" href={pageUrl} />

            {/* JSON-LD structured data */}
            <script type="application/ld+json">
                {JSON.stringify(organizationJsonLd)}
            </script>
            <script type="application/ld+json">
                {JSON.stringify(websiteJsonLd)}
            </script>
            {breadcrumbsJsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(breadcrumbsJsonLd)}
                </script>
            )}
        </Helmet>
    )
}

export default Meta
